import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { FormControlValidatorService } from '../../../sharedServices/form-control-validator.service';
import { UtilsService } from '../../../sharedServices/utils.service';
import { Actions } from '../../../types/actions.type';
import { Flags } from '../../../types/flags.type';
import { MuComponent } from '../../../types/MuComponent.componetent';
import { MuToastService } from 'src/app/components/shared/sharedServices/mu-toast.service';
import { MuCreditWireTransferTypeService } from 'src/app/components/shared/sharedServices/mu-credit-wire-transfer-type.service';
import { CountryShared } from '../../../models/interface/country.interface';
import { DataWireTransferMxShared } from '../../../models/interface/DataWireTransferMx';

@Component({
  selector: 'app-mu-payments-add-wire-transfer',
  templateUrl: './mu-payments-add-wire-transfer.component.html',
  styleUrls: ['./mu-payments-add-wire-transfer.component.sass'],
})
export class MuPaymentsAddWireTransferComponent<ActionType, FlagType> extends MuComponent implements OnChanges {
  @Input() customClass = 'default-express-add-wire-transfer-sizes';
  @Input() actionList: Actions<ActionType, any>;
  @Input() flagList: Flags<FlagType>;
  @Input() formData: UntypedFormGroup;
  @Input() showFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() saveAction: ActionType;
  @Input() cancelAction: ActionType;
  @Input() skin: boolean;
  @Input() country: CountryShared;
  @Input() dataWireTransferMx: DataWireTransferMxShared;
  @Input() showWireFlag: FlagType;
  @Input() checkEmailFlag: FlagType;
  clabe: string;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private elementRef: ElementRef,
    private validator: FormControlValidatorService,
    private muToastService: MuToastService,
    private muCreditWireTransferTypeService: MuCreditWireTransferTypeService,
    public utils: UtilsService
  ) {
    super();

    changeDetector.detach();
  }

  muOnDestroy(): void {
    document.body.removeChild(this.elementRef.nativeElement);
  }

  muOnInit(): void {
    setTimeout(() => this.changeDetector.reattach());
    document.body.appendChild(this.elementRef.nativeElement);
  }

  /**
   * Event emmit action save credit card
   */
  save(): void {
    this.actionList?.emit(this.saveAction, null);
  }

  /**
   * Event emmit action cancel pse
   */
  cancel(): void {
    this.actionList?.emit(this.cancelAction, null);
  }

  /**
   * Event copy
   */
  copy(): void {
    const elementIdMuClabe = document.getElementById('mu-clabe');
    if (!elementIdMuClabe) {
      console.error('Element with ID "mu-clabe" not found.');
      this.muCreditWireTransferTypeService.showToastCopyBoard(this.muToastService, false);
      return;
    }

    const selection = document.createRange();
    selection.selectNodeContents(elementIdMuClabe);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(selection);

    try {
      navigator.clipboard.writeText(selection.toString())
      .then(() => {
        this.muCreditWireTransferTypeService.showToastCopyBoard(this.muToastService, true);
      }, () => {
        this.muCreditWireTransferTypeService.showToastCopyBoard(this.muToastService, false);
      });
    } catch (ex) {
      this.muCreditWireTransferTypeService.showToastCopyBoard(this.muToastService, false);
    }
    window.getSelection().removeRange(selection);
  }

  ngOnChanges(): void {
    if (!this.formData) {
      return environment.guardClause;
    }
  }
}
